import { RG_TYPE } from './rg-type.js';

const RG_TYPE_LIST = Object.values(RG_TYPE);

export { RG_TYPE_LIST };
//# sourceMappingURL=rg-type-list.js.map
